var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M39,12.7l-8.3-8.2c-0.3-0.3-0.6-0.4-1-0.4H9.5C8.9,4.1,8.6,4.5,8.5,5v38 c0,0.5,0.5,1,1,1h28.9c0.5,0,1-0.5,1-1V13.5C39.4,13.2,39.3,12.9,39,12.7z M36,12.5h-5.2l0-5.1L36,12.5z M37.4,42H10.6l0-36h18.2 v7.5c0,0.5,0.5,1,1,1h7.6V42z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M15.6,14.5h8.2c0.6,0,1-0.5,1-1s-0.5-1-1-1h-8.2c-0.6,0-1,0.5-1,1S15,14.5,15.6,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M14.6,20.3c0,0.6,0.5,1,1,1h16.8c0.6,0,1-0.5,1-1s-0.5-1-1-1H15.6 C15.1,19.3,14.6,19.7,14.6,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M32.4,32.8H15.6c-0.6,0-1,0.5-1,1s0.5,1,1,1h16.8c0.6,0,1-0.5,1-1S32.9,32.8,32.4,32.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M32.4,26H15.6c-0.6,0-1,0.5-1,1s0.5,1,1,1h16.8c0.6,0,1-0.5,1-1S32.9,26,32.4,26z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.00508794a944579f45e168f980bbe91d.svg";
export { ForwardRef as ReactComponent };